import React from 'react';
import BookClub from './../assets/images/SATS club/youth/youth_book_club.jpg';

const YouthClubBook = () => {
    return (
        <div style={{ padding: '40px 20px' }}>
            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '20px',
                }}
            >
                {/* Text Section */}
                <div
                    style={{
                        flex: '1 1 500px',
                        backgroundColor: '#fff',
                        padding: '20px',
                        borderRadius: '10px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                    }}
                >
                    <h4 style={{ color: '#007bff', marginBottom: '15px' }}>
                        "A book a month keeps ignorance away!"
                    </h4>
                    <p style={{ lineHeight: 1.6, marginBottom: '15px' }}>
                        <strong>Vanakkam!</strong> <br />
                        SATSYW is happy to invite you all to join the <strong>2025 Book Club</strong> – an exciting
                        opportunity for kids to read and grow together.
                    </p>
                    <p style={{ lineHeight: 1.6, marginBottom: '15px' }}>
                        This monthly book club meets once a month, encouraging children to read, discuss, and express
                        their own views, while nurturing their intellectual growth in a fun and engaging way.
                    </p>
                    <p style={{ fontWeight: 500, marginBottom: '15px' }}>
                        If you're interested, please register on or before{' '}
                        <span style={{ color: 'red' }}>June 30</span>.
                    </p>
                    <a
                        href="https://docs.google.com/forms/d/e/1FAIpQLSc0PTWLtQCE0CUmqSPdTZJKyRJ8JptCOiCA2GnOw3EP62z5mw/viewform?usp=header"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            display: 'inline-block',
                            padding: '8px 16px',
                            backgroundColor: 'green',
                            color: 'white',
                            borderRadius: '5px',
                            textDecoration: 'none',
                            fontSize: '14px',
                        }}
                    >
                        Register for Book Club
                    </a>
                </div>

                {/* Image Section */}
                <div style={{ flex: '1 1 400px', textAlign: 'center' }}>
                    <img
                        src={BookClub}
                        alt="Book Club"
                        style={{
                            width: '100%',
                            maxWidth: '450px',
                            height: 'auto',
                            borderRadius: '10px',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default YouthClubBook;
